import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import DefaultProps from "../../default-props";

export const StyledBadgesGridDesktopComponent = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  margin: auto;
  padding-right: ${({ horizontalPadding }) => horizontalPadding || DefaultProps.horizontalPadding};
  padding-left: ${({ horizontalPadding }) => horizontalPadding || DefaultProps.horizontalPadding};

  .images-gallery-row {
    flex-wrap: nowrap;
    gap: 12px;

    .image-gallery {
      .picture-component {
        img {
          min-width: 72px;
          width: 100%;
          height: 100%;
          object-fit: contain;
          max-width: 120px;
        }
      }
    }
  }
`;
